import { apiSlice } from "../../app/api/apiSlice";

export const galleryCategoriesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // ===============================
    // GET ALL GALLERY CATEGORIES (ADMIN)
    // ===============================
    getGalleryCategories: builder.query({
      query: () => "/api/v1/gallery/categories",
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [
              ...result.map(({ _id }) => ({
                type: "GalleryCategory",
                id: _id,
              })),
              { type: "GalleryCategory", id: "LIST" },
            ]
          : [{ type: "GalleryCategory", id: "LIST" }],
    }),

    // ===============================
    // CREATE GALLERY CATEGORY
    // ===============================
    addGalleryCategory: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/gallery/categories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "GalleryCategory", id: "LIST" }],
    }),

    // ===============================
    // UPDATE GALLERY CATEGORY
    // ===============================
    updateGalleryCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/v1/admin/gallery/categories/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "GalleryCategory", id: arg.id },
      ],
    }),

    // ===============================
    // DELETE GALLERY CATEGORY
    // ===============================
    deleteGalleryCategory: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/gallery/categories/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "GalleryCategory", id: "LIST" }],
    }),

  }),
});

export const {
  useGetGalleryCategoriesQuery,
  useAddGalleryCategoryMutation,
  useUpdateGalleryCategoryMutation,
  useDeleteGalleryCategoryMutation,
} = galleryCategoriesApiSlice;
